import { IToggleCollapseAction } from '../interfaces/theme/actions.interface';
import { ThemeActionTypes } from '../constants/theme';

export const toggleCollapseAction = (payload?: boolean | undefined): IToggleCollapseAction => ({
  type: ThemeActionTypes.TOGGLE_COLLAPSE,
  payload,
});
